import {coral} from '../primitives/color';
import styled from 'styled-components';

export const TextButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: ${coral.regular};
  padding: 0 16px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;
